import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */
/*
PROPS:
props.w
props.maxWidth
props.minWidth
props.maximize
props.minimize
props.fullWidth
props.extraClass
*/

const UniPaginationMuiTablePagination = (props) => {
  let paginationPack = {};
  if (props?.paginationPack?.pagination_page_no) {
    paginationPack = props.paginationPack;
  }
  const {
    pagination_per_page, // TODO
    pagination_page_no,
    pagination_prev_page_no,
    pagination_next_page_no,
    pagination_pages_count,
    _handleChangePagination_rowsPerPage,
    _handleClickPaginationPagePrev,
    _handleClickPaginationPageNext,
  } = paginationPack;

  let cl = '';
  /*
  if (props.maximize === true) { // unlimit the limiter
    cl = " unicompo-limiter--maximize";
  }
  if (props.minimize === true) {
    cl = " unicompo-limiter--minimize";
  }
  if (props.fullWidth === true) { // width to 100%
    cl = " unicompo-limiter--full-width";
  }
  */

  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    extraClass = ' ' + props.extraClass;
  }

  return (
    <div className="UniPaginationMuiTablePagination unicompo-pagination-mui-table-pagination">
      <div className="unicompo-pagination-mui-table-pagination MuiTablePagination-toolbar">
        <div className="unicompo-pagination-mui-table-pagination__push-right MuiTablePagination-spacer"></div>
        <p id="«r1»" className="MuiTablePagination-selectLabel">Rows per page:</p>
        <div className="unicompo-pagination-mui-table-pagination__select MuiTablePagination-select">
          {/*<input aria-invalid="false" aria-hidden="true" tabindex="-1" className="MuiSelect-nativeInput css-147e5lo" value="5" />*/}
          {/*
        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiTablePagination-selectIcon MuiSelect-iconStandard css-1704qq4" focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"></path></svg>
        */}
          <select
            disabled={false}
            name={'name'}
            value={pagination_per_page}
            onChange={(e) => { _handleChangePagination_rowsPerPage(e.target.value) }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={10}>15</option>
            <option value={20}>20</option>
            <option value={20}>25</option>
            <option value={50}>50</option>
            <option value={''}>All</option>
          </select>
        </div>
        <p className="MuiTablePagination-displayedRows css-wqp0ve">{pagination_page_no} of {pagination_pages_count}</p>
        <div className="unicompo-pagination-mui-table-pagination__actions MuiTablePagination-actions">
          <div className={"unicompo-pagination-mui-table-pagination__btn" + (pagination_prev_page_no > 0 ? "" : " unicompo-pagination-mui-table-pagination__btn--disabled")} onClick={() => {
            if (pagination_prev_page_no > 0) { _handleClickPaginationPagePrev(); }
          }}>
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
          </div>
          <div className={"unicompo-pagination-mui-table-pagination__btn" + (pagination_next_page_no > 0 ? "" : " unicompo-pagination-mui-table-pagination__btn--disabled")} onClick={() => {
            if (pagination_next_page_no > 0) { _handleClickPaginationPageNext(); }
          }}>
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniPaginationMuiTablePagination;